import { guid } from 'helpers/index'

export function add (message, type = 'error', options = {}) {
  return {
    type: 'NOTIFICATIONS_ADD',
    id: guid(),
    notification_type: type,
    message,
    ...options
  }
}

export function remove (id) {
  return {
    type: 'NOTIFICATIONS_REMOVE',
    id
  }
}

export const actions = { add, remove }

// Action Handlers
const ACTION_HANDLERS = {
  NOTIFICATIONS_ADD: (state, action) => {
    // with this, we're pushing everything but the action.type to the state
    const { type, ...data } = action // eslint-disable-line no-unused-vars

    if (!Array.isArray(state)) state = []
    state = state.filter(o => o.id !== action.id)
      .filter(o => o.message !== action.message && o.notification_type !== action.notification_type)

    state.push(data)

    return state
  },
  NOTIFICATIONS_REMOVE: (state, action) => {
    return state.filter(o => o.id !== action.id)
  }
}

// Reducer
const initialState = []

// NOTE: This `reducer` doesn't seem to be going anywhere....
export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/notifications.js